module.exports = __webpack_public_path__ + "img/jingjiguangbo.0e5ff2ef.jpg";